// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"7761958ed283a021","5763":"2d15ea3596e42bbb","6893":"73a2165570c2e53f","6974":"13e8d78f234be0c8","7222":"d5589c6b0dd670da","7937":"bcb742c941331978"}[chunkId] + ".js";
};